module.exports = __webpack_public_path__ + "static/img/slingshot.cf98944.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/brands/slingshot.jpg
// module id = H0Ht
// module chunks = 1